/**
 * Staff member model (spec section 14).
 *
 * Pure serializable data. Salary is copied from the type def at hire time so a
 * later salary rebalance doesn't retroactively change existing hires (and so
 * P&L is computed from the member itself). efficiency/skill/morale are present
 * per spec; Phase 6 uses defaults and lets managers amplify effectiveness.
 */
export interface StaffMember {
  id: string;
  typeId: string; // 'cashier' | 'security' | 'cleaner' | 'manager' | 'technician'
  salary: number; // monthly
  efficiency: number; // 0..1
  skill: number; // 0..1
  morale: number; // 0..1
}

export interface CreateStaffOptions {
  id: string;
  typeId: string;
  salary: number;
}

export function createStaffMember(options: CreateStaffOptions): StaffMember {
  return {
    id: options.id,
    typeId: options.typeId,
    salary: options.salary,
    efficiency: 1,
    skill: 1,
    morale: 1,
  };
}
